import React from "react";
import { Link } from "react-router-dom";
const NoItems = ({ setLength }) => {
	return (
		<Link to='/'>
			<button
				className='bg-custom-green py-3 px-5 rounded text-white w-full'
				onClick={() => {
					alert("Order competed!!");
					localStorage.clear();
					setLength();
				}}>
				Buy Now
			</button>
		</Link>
	);
};

export default NoItems;
